import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P81-E1",
    audio: "img/FriendsPlus/Page80/Audio/audio-e3-p80.mp3",
    video: "Videos/e3.p80.mp4",
    component: UI,
    recorder: true,
    question: [],
    titleQuestion: [{ color: "#445012f", num: "1", title: 'Listen to the story and repeat. Act.' }],
    questionImage: [
      // Row
      [
        // Column3
        { url: "img/FriendsPlus/Page80/E3/4.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh1-e3-p80.mp3", },
        { url: "img/FriendsPlus/Page80/E3/5.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh2-e3-p80.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page80/E3/6.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh3-e3-p80.mp3", },
        { url: "img/FriendsPlus/Page80/E3/7.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh4-e3-p80.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page80/E3/8.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh5-e3-p80.mp3", },
        { url: "img/FriendsPlus/Page80/E3/9.jpg", audioUrl: "img/FriendsPlus/Page80/Audio/hinh6-e3-p80.mp3", },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P81-E2",
    audio: "img/FriendsPlus/Page81/Audio/audio-e2-p81.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page81/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page81/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page81/Audio/tieude-e2-p81.mp3",
        },
        { url: "img/FriendsPlus/Page81/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page81/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page81/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page81/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page81/Audio/hinh1-e2-p81.mp3",
        },
        {
          url: "img/FriendsPlus/Page81/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page81/Audio/hinh2-e2-p81.mp3",
        },
        {
          url: "img/FriendsPlus/Page81/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page81/Audio/hinh3-e2-p81.mp3",
        },
        {
          url: "img/FriendsPlus/Page81/E2/9.jpg",
          audioUrl: "img/FriendsPlus/Page81/Audio/hinh4-e2-p81.mp3",
        },
        { url: "img/FriendsPlus/Page81/E2/10.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page81/E2/11.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P81-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page81/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P81-E4",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page81/E4/Key/answerKey.png",
    inputSize: 200,
    checkUppercase: true,
    titleImage: "",
    titleQuestion: [{ color: "#445012f", num: "4", title: 'Look again and write.' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <img src="img/FriendsPlus/Page81/E4/1.jpg" style="width: 100%">
            <div style='display: flex; flex-direction: row;position: relative;'>
              <div style='flex: 1;'>
                <div><b>1</b>&ensp;She<u style='text-decoration-color: black;color:rgb(82,1127,235)'>&ensp;was&ensp;</u> good.</div>
                <div><b>3</b>&ensp;He # bad.</div>
                <div><b>5</b>&ensp;She # cold.</div>
              </div>
              <div style='flex: 1;'>
                <div><b>2</b>&ensp;They # wet.</div>
                <div><b>4</b>&ensp;The girl # dry.</div>
              </div>
            </div>
          </div>
        `,
        answer: ["was", "wasn't", "weren't", "wasn't"],
      },
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P81-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page81/E5/1.jpg" }]],
  },
};

export default json;
